import get from 'lodash/get';
import {styleClasses} from '@brand/settings';

function dateDifference(date) {
	let diff = parseInt((new Date() - new Date(date)) / 1000);
	return isNaN(diff) ? 0 : diff;
}

function toTime(str) {
	let d = new Date(str);
	if (isNaN(d)) return str;
	return `${d.getHours()}:${d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes() } ${d.getHours() > 11 ? 'PM' : 'AM'}`;
}

function convertToPoundsString(str) {
	let n = Number.parseFloat(str);
	if (!str || isNaN(n) || n < 0) return 0;
	return n.toFixed(2);
}

function convertToPoundsInt(str) {
	let n = Number.parseFloat(str);
	if (!str || isNaN(n) || n < 0) return 0;
	return Number(n.toFixed(2));
}

function quickCompareObjects(a, b) {
	return JSON.stringify(a) === JSON.stringify(b);
}

function convertNumberToPounds(number) {
	return number.toLocaleString('en-gb', {style: 'currency', currency: 'GBP'});
}

/**
 *	updateLineItemPrice
 *	Calculate total prices for lineItem, taking into consideration choices and item quantity.
 *	@param {Object} [item] - LineItem from state basket
 *	@return {Object} [item] - LineItem with updated totalPrice & choicePriceTotal
 */
function updateLineItemPrice(item) {

	const choices = item.choices;
	let choicePriceTotal = 0;

	for (let choiceKey in choices) {
		const choiceGroup = choices[choiceKey];
		for (let choiceGroupKey in choiceGroup) {
			const choice = choiceGroup[choiceGroupKey];
			const quantity = choice.portion.quantity;
			const price = (choice.product.portions[0].price) ? choice.product.portions[0].price : 0;
			choicePriceTotal += price * quantity;
		}
	}

	const totalPrice = (item.basePrice + choicePriceTotal) * item.quantity;
	item.choicePriceTotal = choicePriceTotal;
	item.totalPrice = totalPrice;

	return item;
}

/**
 *	getItemById
 *	This often used to match default portion/displaynames/etc ids with the portion object
 * 	@param  {Number} id - id to match with
 *  @param  {Array} portions - array to match on
 *  @return {Object} - matched object
 */
function getItemById(id, array) {
	return array.find((item) => {
		return item.id === id;
	});
}

const helpers = {
	methods: {
		identicleObjs: (a, b) => quickCompareObjects(a, b),
		getAge: d => dateDifference(d),
		toTime: (str) => toTime(str),
		getProp: (obj, path, def) => get(obj, path, def),
		toPoundStr: (str) => convertToPoundsString(str),
		toPoundInt: (str) => convertToPoundsInt(str),
		numberToPounds: (number) => convertNumberToPounds(number),
		styleClass: (str) => styleClasses[str] || '',
		updateLineItemPrice: (obj) => updateLineItemPrice(obj),
		getItemById: (number, obj) => getItemById(number, obj)
	},
	filters: {
		toTime: (str) => toTime(str)
	}
};

export default helpers;



// WEBPACK FOOTER //
// ./src/vue/helpers.js